import Phaser from 'phaser';
import { TEXTURE_KEYS } from '../assets/assetKeys';
import { VISUAL_THEME } from '../assets/visualTheme';
import { GAME_HEIGHT, GAME_WIDTH, SCENE_KEYS } from '../data/gameConstants';
import { SaveSystem } from '../systems/SaveSystem';
import { OverlayInputLock } from '../systems/OverlayInputLock';
import { ResponsiveSystem } from '../systems/ResponsiveSystem';
import { NameInputOverlay } from '../ui/NameInputOverlay';
import { getPanelBounds, getTitleY, getModalPanelHeight, getModalBodyTop, getModalDividerY } from '../ui/PanelLayout';
import { UIStyle } from '../ui/UIStyle';
import { SceneTransition } from '../utils/SceneTransition';

export class NameInputScene extends Phaser.Scene {
  private nameOverlay?: NameInputOverlay;

  constructor() {
    super({ key: 'NameInputScene' });
  }

  create(): void {
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
    const layout = ResponsiveSystem.getUILayout(this);
    const isCompact = layout.isCompact;

    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, TEXTURE_KEYS.BG_MENU)
      .setDisplaySize(GAME_WIDTH, GAME_HEIGHT);
    this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, 0x000000, VISUAL_THEME.menuDimAlpha + 0.06);

    const panelW = isCompact ? 480 : 540;
    const panelH = getModalPanelHeight(layout.buttonHeight, {
      actionButtons: 2,
    }) + 26;
    const bounds = getPanelBounds(this, panelW, panelH);
    const { panelX, panelY, panelTop, panelW: clampedW, panelH: clampedH } = bounds;
    const bodyTop = getModalBodyTop(panelTop);
    const inputInsetX = 52;
    const inputRowTop = bodyTop + 20;

    UIStyle.createModalSurface(this, panelX, panelY, clampedW, clampedH);

    this.add.rectangle(panelX, getModalDividerY(panelTop), clampedW - 56, 2, 0xe7c487, 0.42);

    this.add.text(panelX, getTitleY(panelTop), 'Siapa Namamu?', {
      ...UIStyle.panelTitle(isCompact ? UIStyle.px(28) : UIStyle.px(30)),
    }).setOrigin(0.5);

    this.nameOverlay = new NameInputOverlay();
    this.nameOverlay.configure({
      placeholder: 'Contoh: Bujang',
      maxLength: 24,
      onSubmit: () => this.startGame(),
      onChange: () => this.nameOverlay?.clearError(),
      onBack: () => this.goBack(),
    });
    this.nameOverlay.setGameAnchor(
      panelX,
      inputRowTop,
      clampedW - inputInsetX * 2,
      'top',
    );
    this.nameOverlay.show(this);
  }

  private startGame(): void {
    const name = this.nameOverlay?.getValue() ?? '';
    if (!name) {
      this.nameOverlay?.showError('Nama wajib diisi.');
      this.nameOverlay?.focus();
      return;
    }
    SaveSystem.createNew(name);
    SaveSystem.saveProgress(SCENE_KEYS.ZONE1, 1);
    this.cleanup();
    SceneTransition.startNextFrame(this, SCENE_KEYS.ZONE1);
  }

  private goBack(): void {
    this.cleanup();
    SceneTransition.startNextFrame(this, SCENE_KEYS.MAIN_MENU);
  }

  private cleanup(): void {
    this.nameOverlay?.hide();
    OverlayInputLock.release(this);
  }

  shutdown(): void {
    this.cleanup();
    this.nameOverlay?.destroy();
  }
}
